module.exports = __webpack_public_path__ + "img/unpublished.37e621dc.png";